import {Text} from "../components/Shared";
import {solease_gray_3} from "../../constants/Colors";

const Final = () => {

    return (
        <>
            <Text large style={{textAlign: "center", marginTop: '150px', color: solease_gray_3}}>
                {'Bedankt voor het invullen van de \nvragen!\nJe kan nu dit venster sluiten'}
            </Text>
        </>
    )
}

export default Final
